var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48,40c0-2.77-.17-5.42-.42-8h-15.15c-.25,2.58-.42,5.23-.42,8,0,2.39.12,5.09.41,8h15.18c.28-2.91.41-5.61.41-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40,75.43c3.24-6.82,5.2-13.41,6.39-19.43h-12.77c1.18,6.02,3.15,12.61,6.39,19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.53,24h22.1C71.34,11.95,60.29,2.36,46.99,0c3.02,6.3,5.89,14.8,7.55,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56,40c0,2.4-.13,5.12-.39,8h23.58c.53-2.59.81-5.26.81-8s-.28-5.41-.81-8h-23.56c.23,2.59.37,5.24.37,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40,4.59c-2.52,5.33-4.88,11.85-6.38,19.41h12.76c-1.5-7.56-3.86-14.09-6.38-19.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.54,56c-1.28,7.15-3.59,15.77-7.55,24,13.3-2.36,24.35-11.96,29.64-24h-22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.47,24c1.66-9.2,4.53-17.7,7.55-24C19.71,2.36,8.66,11.95,3.37,24h22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.46,56H3.37c5.29,12.04,16.34,21.64,29.64,24-3.96-8.23-6.27-16.85-7.55-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24,40c0-2.76.14-5.41.37-8H.81c-.53,2.59-.81,5.26-.81,8s.28,5.41.81,8h23.58c-.26-2.88-.39-5.6-.39-8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.f725dad1.svg";
export { ForwardRef as ReactComponent };